import type { ReactNode } from 'react';
import type { EligibilityBlocker } from '../../api';
import { eligibilityBlockerLabel, humanize } from '../../labels';

/**
 * EligibilityBlockers lists what stops blue-green runtimes as data: a label per
 * code and its items (agent commands, the ingress in use, storefront names).
 * The server judges with the same eligibility its deployment plans use; with no
 * structured blockers (an older server) the server's own reason is shown.
 */
export function EligibilityBlockers({ blockers, fallback, testId }: { blockers?: EligibilityBlocker[]; fallback?: ReactNode; testId?: string }) {
  if (!blockers || blockers.length === 0) return fallback ? <>{fallback}</> : null;
  return (
    <ul className="runtime-list__reasons" data-testid={testId}>
      {blockers.map((b) => (
        <li key={b.code}>
          {eligibilityBlockerLabel[b.code] ?? humanize(b.code)}
          {b.items && b.items.length > 0 ? ': ' : ''}
          {(b.items ?? []).map((item, i) => (
            <span key={item}>
              {i > 0 ? ', ' : ''}
              <code translate="no">{item}</code>
            </span>
          ))}
        </li>
      ))}
    </ul>
  );
}
